import {vnTemplate} from "./vnTemplate";

declare let ko: any;
declare let AmCharts: any;

export abstract class amCharts_template extends vnTemplate{

    public options: any;
    public mainClass: any;

    protected getTemplateHtml(): string{

        return `
                <div data-bind="attr: {id: idChart}" class="ratio-content"></div>
                `;
    }

    protected getMainElementClasses(): Array<string>{
    	return this.mainClass;
    }

    protected buildViewModel(): any{

        let _this = this;

        return  { idChart: ko.observable("chartDiv_" + _this.idElement) };
    }

    public setData(data: Array<any>){
        this.options["dataProvider"] = data;
    }

    // play with options
    public setOptions(options: any){
        this.options = options;
    }

    public setOption(name: string, options: any){

        this.options[name] = options;
    }

    public setMainClass(mainClass){
        this.mainClass = mainClass;
    }

    public drawChart(){

        let chartDiv = 'chartDiv_' + this.idElement;

        AmCharts.makeChart(chartDiv, this.options);

    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/amCharts_template.ts